import { render } from "./Publish.vue?vue&type=template&id=31f69e78"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Publish.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31f69e78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31f69e78', __exports__)) {
    api.reload('31f69e78', __exports__)
  }
  
  module.hot.accept("./Publish.vue?vue&type=template&id=31f69e78", () => {
    api.rerender('31f69e78', render)
  })

}


export default __exports__